
import Vue from "vue";
import { API_URL } from ".";
import StorageMediaFileFilter from "../filters/StorageMediaFileFilter";
import PlanReportsFilter from "../filters/PlanReportsFilter";

Vue.http.headers.common['Accept'] = 'application/json'
Vue.http.headers.common['Content-Type'] = 'application/json'
Vue.http.headers.common['Content-Type'] = 'application/json'

export function getStorageMediaFile(payload = StorageMediaFileFilter()) {
    let json = JSON.stringify(payload);
    var params = "?query=" + encodeURIComponent(json)
    return Vue.http.get(API_URL + "/images/" + params);
}

export function getStorageDocumentMediaFile(payload = StorageMediaFileFilter()) {
    let json = JSON.stringify(payload);
    var params = "?query=" + encodeURIComponent(json)
    return Vue.http.get(API_URL + "/documents/" + params);
}

export function getPlanReports(payload = PlanReportsFilter()) {
    let json = JSON.stringify(payload);
    var params = "?query=" + encodeURIComponent(json)
    return Vue.http.get(API_URL + "/plan/reports" + params);
}


// WEBPACK FOOTER //
// ./resources/js/api/directapi.js